const setEnableSourceDataDownload = (enableSourceDataDownload) => ({
    type: 'SET_ENABLE_SOURCE_DATA_DOWNLOAD',
    enableSourceDataDownload,
});

export default setEnableSourceDataDownload;
